export const MerchantSelectionErrorViewUat = {
  message: 'merchantSelection.errorView.message',
}
